@if (form) {
  <form [formGroup]="form" class="{{fieldData.form.display?.cssClasses}}" [ngClass]="{'uk-hidden clear-style': hideField}">
    <!--  {{fieldData.name | json}}-->
    @if (fieldData.label?.text) {
      <div class="uk-form-label uk-margin-bottom {{fieldData.label?.cssClasses}}"
        [attr.for]="fieldData.name" style="{{fieldData.label.style}}">
        {{fieldData.label?.text + (fieldData.form.mandatory ? ' (*)' : '')}}
      </div>
    }
    @if (fieldData.form.description?.showLess) {
      @if (fieldData.form.description.text) {
        <div class="uk-form-description uk-text-small uk-margin-bottom uk-width-9-10 {{fieldData.form.description.cssClasses}}"
          style="{{fieldData.form.description.style}}">
          <read-more-text [maxHeight]="46" [text]="fieldData.form.description.text"></read-more-text>
        </div>
      }
    } @else {
      @if (fieldData.form.description?.text) {
        <div class="uk-form-description uk-text-small uk-margin-bottom uk-width-9-10 {{fieldData.form.description.cssClasses}}"
             [innerHTML]="fieldData.form.description.text" style="{{fieldData.form.description.style}}">
        </div>
      }
    }
    @if (fieldData.typeInfo.multiplicity) {
      <div>
        @for (arrayControl of fieldAsFormArray().controls; track arrayControl; let i = $index) {
          <div>
            <!-- Show radio so user can choose one-->
            <div class="uk-margin-small-bottom">
              @for (field of fieldData.subFields; track field; let j = $index) {
                <div>
                  <label class="uk-form-label">
                    <input class="uk-radio uk-margin-small-right" type="radio" [name]="i+'-'+fieldData.name" [checked]="j===0"
                      (click)="chooseOne(field.name, i)">
                    {{field.label.text}}
                  </label>
                </div>
              }
            </div>
            <div [formGroupName]="i" class="uk-width-9-10 uk-display-inline-block" [ngClass]="{'uk-margin-bottom formGroupElement': $safeNavigationMigration(fieldData.form.display?.hasBorder)}">
              @for (control of fieldData?.subFields; track control; let j = $index) {
                <div>
                  <div class="">
                    @if (getGroupOfArray(i).contains(control.name)) {
                      <div>
                        @if (control.typeInfo.type === 'composite') {
                          <app-composite-field [fieldData]="control" [subVocabularies]="subVocabularies"
                            [vocabularies]="vocabularies" (hasChanges)="unsavedChangesPrompt()"
                            [position]="i" (handleBitSets)="handleBitsetOfChildren($event)"
                            (handleBitSetsOfComposite)="handleCompositeBitsetOfChildren($event)">
                          </app-composite-field>
                        }
                        @if (control.typeInfo.type === 'string' || control.typeInfo.type === 'email' ||
                             control.typeInfo.type === 'phone' || control.typeInfo.type === 'url') {
                          <app-string-url-email-field [fieldData]="control" [position]="i"
                                                      (hasChanges)="unsavedChangesPrompt()"
                                                      (handleBitSets)="handleBitsetOfChildren($event)"
                                                      (handleBitSetsOfComposite)="handleCompositeBitsetOfChildren($event)">
                          </app-string-url-email-field>
                        }
                      </div>
                    }
                  </div>
                </div>
              }
            </div>
            @if (fieldAsFormArray().length > 1) {
              <a class="remove-element uk-padding-small uk-display-inline-block"
                (click)="remove(i); updateBitSetOfComposite(fieldData, i); unsavedChangesPrompt();">
                <span class="material-icons">clear</span>
              </a>
            }
          </div>
        }
        @if (form.enabled) {
          <div class="uk-width-9-10 uk-text-center uk-margin-top">
            <a class="add-new-element uk-flex uk-flex-middle uk-flex-center" (click)="pushComposite(fieldData)">
              <span class="material-icons">add</span>Add &nbsp;<span [innerHTML]="fieldData.label.text"></span>
            </a>
          </div>
        }
      </div>
    } @else {
      <!-- Show radio so user can choose one-->
      <div class="uk-margin-small-bottom">
        @for (field of fieldData.subFields; track field; let i = $index) {
          <div>
            <label class="uk-form-label">
              <input class="uk-radio uk-margin-small-right" type="radio" [name]="fieldData.name" [checked]="i===0"
                (click)="chooseOne(field.name)">
              {{field.label.text}}
            </label>
          </div>
        }
      </div>
      <div class="uk-width-1-1 uk-display-inline-block" [ngClass]="{'uk-margin-bottom formGroupElement': $safeNavigationMigration(fieldData.form.display?.hasBorder)}">
        @for (control of fieldData?.subFields; track control; let j = $index) {
          <div>
            <div class="">
              @if (this.form.contains(control.name) && control.typeInfo.type === 'composite') {
                <div>
                  <app-composite-field [fieldData]="control" [subVocabularies]="subVocabularies" [vocabularies]="vocabularies"
                    (handleBitSets)="handleBitsetOfChildren($event)" (hasChanges)="unsavedChangesPrompt()"
                    (handleBitSetsOfComposite)="handleCompositeBitsetOfChildren($event)">
                  </app-composite-field>
                </div>
              }
            </div>
          </div>
        }
      </div>
    }
    @if (fieldData.form.suggestion?.text) {
      <div class="uk-margin-top">
        <div class="uk-suggestion uk-width-9-10 {{fieldData.form.suggestion.cssClasses}}" style="{{fieldData.form.suggestion.style}}" [innerHTML]="fieldData.form.suggestion.text"></div>
      </div>
    }
  </form>
}
<!--<pre>{{fieldData | json}}</pre>-->
<!--<pre>{{form.getRawValue() | json}}</pre>-->
